import React from "react";

import "./css/categoriesEdit.css";

import { Link } from "react-router-dom";
import * as ROUTES from "../../../../constants/routes";

import {
  TextField,
  Fade,
  FormHelperText,
  Button,
  CircularProgress,
  Snackbar,
  Chip,
} from "@material-ui/core";

import { AttachFile } from "@material-ui/icons";

import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const CategoryEditForm = (props) => {
  const {
    categoryCode,
    categoryTitle,
    categoryDescription,
    categoryOrder,
    categoryCodeError,
    categoryTitleError,
    categoryDescriptionError,
    categoryIconError,
    fileName,
    iconPreview,
    existingIconUrl,
    toggleAlert,
    messageType,
    messageAlert,
    toggleActionAlert,
    isLoading,
  } = props.state;

  return (
    <>
      <div className={"categoriesEditRoot"}>
        <form onSubmit={props.onSubmit()}>
          <div className={"categoriesEditContainer"}>
            <label className={"categoriesEditHeader"}>Edit Category</label>

            {toggleAlert && (
              <>
                <MuiAlert elevation={1} variant="filled" severity={messageType}>
                  {messageAlert}
                </MuiAlert>
                <br />
              </>
            )}

            <label className={"categoriesEditTitle"}>Category Code</label>

            <TextField
              name="categoryCode"
              inputProps={{ className: "categoriesEditTextBox" }}
              variant="outlined"
              value={categoryCode}
              onChange={props.onChange()}
              placeholder="Category code..."
              autoComplete="off"
              required
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryCodeError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesEditTitle"}>Category Title</label>

            <TextField
              name="categoryTitle"
              inputProps={{ className: "categoriesEditTextBox" }}
              variant="outlined"
              value={categoryTitle}
              onChange={props.onChange()}
              placeholder="Category title..."
              autoComplete="off"
              required
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryTitleError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesEditTitle"}>Description</label>

            <TextField
              name="categoryDescription"
              inputProps={{ className: "categoriesEditDescription" }}
              variant="outlined"
              value={categoryDescription}
              onChange={props.onChange()}
              placeholder="Category description..."
              autoComplete="off"
              multiline
              rows={8}
            />
            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryDescriptionError}
              </FormHelperText>
            </Fade>

            <br />
            <label className={"categoriesEditTitle"}>Display Order</label>

            <TextField
              name="categoryOrder"
              inputProps={{ className: "categoriesEditTextBox", min: 1 }}
              variant="outlined"
              type="number"
              value={categoryOrder}
              onChange={props.onChange()}
              placeholder="1, 2, 3..."
              autoComplete="off"
            />
            <FormHelperText style={{ color: "gray" }}>
              Lower numbers appear first. Leave empty to appear last.
            </FormHelperText>

            <br />
            <label className={"categoriesEditTitle"}>Icon</label>
            <input
              name="categoryIcon"
              type="file"
              accept=".jpg,.jpeg,.png"
              className={"categoriesEditUpload"}
              onChange={props.onChange()}
            />
            <FormHelperText style={{ color: "gray" }}>
              Min: 50x50px - Max: 1000x1000px (Width x Height)
            </FormHelperText>

            <Fade in={true}>
              <FormHelperText style={{ color: "red" }}>
                {categoryIconError}
              </FormHelperText>
            </Fade>

            {fileName && (
              <div>
                <Chip
                  icon={<AttachFile className={"categoriesEditUploadIconSize"} />}
                  label={fileName}
                  className={"categoriesEditUploadChip"}
                  color="secondary"
                />
              </div>
            )}

            {(iconPreview || existingIconUrl) && (
              <div className={"categoriesEditIconPreview"}>
                <img
                  src={iconPreview || existingIconUrl}
                  alt="Category icon preview"
                  className={"categoriesEditIconImage"}
                />
              </div>
            )}

            <br />
            <div>
              <Button
                component={Link}
                to={ROUTES.CATEGORIES_LIST}
                style={{ pointerEvents: isLoading ? "none" : "all" }}
                className={"categoriesEditCancelButton"}
              >
                Cancel
              </Button>
              {!isLoading ? (
                <Button type="submit" className={"categoriesEditEditButton"}>
                  Save
                </Button>
              ) : (
                <CircularProgress className={"categoriesEditLoading"} />
              )}
            </div>
          </div>
        </form>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        autoHideDuration={3000}
        open={toggleActionAlert}
        onClose={props.onhandleClose()}
      >
        <Alert onClose={props.onhandleClose()} severity={messageType}>
          {messageAlert}
        </Alert>
      </Snackbar>
    </>
  );
};

export default CategoryEditForm;
